/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Board_Kind_IdeaInputs */

const en_us2_board_kind_idea = /** @type {(inputs: Board_Kind_IdeaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idea`)
};

const pt_br2_board_kind_idea = /** @type {(inputs: Board_Kind_IdeaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideia`)
};

const pt_pt2_board_kind_idea = /** @type {(inputs: Board_Kind_IdeaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideia`)
};

/** @type {(inputs: Board_Kind_IdeaInputs) => LocalizedString} */
const es_419_board_kind_idea = en_us2_board_kind_idea;

/** @type {(inputs: Board_Kind_IdeaInputs) => LocalizedString} */
const fr_fr2_board_kind_idea = en_us2_board_kind_idea;

/** @type {(inputs: Board_Kind_IdeaInputs) => LocalizedString} */
const de_de2_board_kind_idea = en_us2_board_kind_idea;

/** @type {(inputs: Board_Kind_IdeaInputs) => LocalizedString} */
const it_it2_board_kind_idea = en_us2_board_kind_idea;

/**
* | output |
* | --- |
* | "Idea" |
*
* @param {Board_Kind_IdeaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const board_kind_idea = /** @type {((inputs?: Board_Kind_IdeaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Board_Kind_IdeaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_board_kind_idea(inputs)
	if (locale === "es-419") return es_419_board_kind_idea(inputs)
	if (locale === "pt-PT") return pt_pt2_board_kind_idea(inputs)
	if (locale === "fr-FR") return fr_fr2_board_kind_idea(inputs)
	if (locale === "de-DE") return de_de2_board_kind_idea(inputs)
	if (locale === "it-IT") return it_it2_board_kind_idea(inputs)
	return en_us2_board_kind_idea(inputs)
});
export { board_kind_idea as "board.kind_idea" }